import { FavouriteAdminTranslation } from 'app/area/favourite-administration/constants';
import { ComplexValue, ValidationLevel, ValidationMessage } from 'ui';
import { languageValidationParameter } from '../constants';
import { FavouriteItem, FavouriteItemValidation } from '../types-store';
import { FavouriteFormIds } from 'app/area/favourite-administration/form/constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { isOwnerReadOnly } from 'app/area/favourite-administration/form/components/helpers';

const validationMessageHelper = (propName: string, messages: ValidationMessage | ValidationMessage[]) => {
  return {
    [propName]: {
      level: ValidationLevel.error,
      messages
    }
  };
};

export const validateFavourite = (
  favourite: FavouriteItem,
  languageOptions: ComplexValue<number>[],
  translation: FavouriteAdminTranslation
): FavouriteItemValidation => {

  const defaultValidationError = {
    level: ValidationLevel.error,
    message: translation.must_be_filled_out
  };

  const allLanguages = (languageOptions || [])
    .map(option => (favourite?.language || [])
      .find(language => language.value === option.value)
      || { value: option.value }
    );

  const languageValidation = allLanguages
    .map(language =>
      language.description === undefined || language.description.trim() === ''
        ? {
          ...defaultValidationError,
          parameters: {
            [languageValidationParameter]: language.value
          }
        } as ValidationMessage
        : undefined
    )
    .filter(validation => !!validation);

  const favouriteTypeValidation = !isDefinedIncludingZero(favourite?.favouriteType)
    ? defaultValidationError
    : undefined;

  const ownerValidation = !(favourite?.owners?.length > 0)
    ? defaultValidationError
    : undefined;

  return {
    ...(languageValidation.length > 0 && validationMessageHelper(FavouriteFormIds.language, languageValidation)),
    ...(!!favouriteTypeValidation && validationMessageHelper(FavouriteFormIds.favouriteType, [favouriteTypeValidation])),
    ...(!isOwnerReadOnly(favourite?.id) && !!ownerValidation && validationMessageHelper(FavouriteFormIds.owners, [ownerValidation]))
  };
};
